import { forwardRef, memo, type ReactNode } from 'react';
import clsx from 'clsx';
// Material UI imports
import Box, { type BoxProps } from '@mui/material/Box';
import Card from '@mui/material/Card';
import CircularProgress from '@mui/material/CircularProgress';
// SCSS imports
import { card, lowMargin } from './ContentCard.module.scss';

type ContentCardProps = {
  readonly children: ReactNode;
  readonly pending?: boolean | null;
  // loading?: boolean | null;
  readonly withoutTopMargin?: boolean;
  readonly className?: string;
  readonly sx?: BoxProps['sx'];
};

const ContentCard = forwardRef<HTMLDivElement, ContentCardProps>(({
  pending = false,
  // loading = false,
  children,
  className,
  withoutTopMargin = false,
  sx
}, ref) => pending ? (
  <Box
      ref={ref}
      sx={sx}
      flexGrow={1}
      color="action.disabled"
      alignItems="center"
      className={withoutTopMargin ? lowMargin : card}
  >
    <CircularProgress color="inherit" size="2.25rem"/>
  </Box>
) : (
  <Card
      ref={ref}
      sx={sx}
      raised
      className={clsx(className, {
        [card]: !withoutTopMargin,
        [lowMargin]: withoutTopMargin
      })}
  >
    {children}
  </Card>
));

ContentCard.displayName = 'ContentCard';

export default memo(ContentCard);
